// src/theme-provider/styles/global-typography.ts
import { css } from "@emotion/react";
var global_typography_default = css`
  html {
    font-family: 'Nunito', sans-serif;
  }

  h1 {
    font-size: var(--fontSizes-h1);
    line-height: var(--lineHeights-h1);
  }

  h2 {
    font-size: var(--fontSizes-h2);
    line-height: var(--lineHeights-h2);
  }

  h3 {
    font-size: var(--fontSizes-h3);
    line-height: var(--lineHeights-h3);
  }

  h4 {
    font-size: var(--fontSizes-h4);
    line-height: var(--lineHeights-h4);
  }

  h5 {
    font-size: var(--fontSizes-h5);
    line-height: var(--lineHeights-h5);
  }

  h6 {
    font-size: var(--fontSizes-h6);
    line-height: var(--lineHeights-h6);
  }
`;

export {
  global_typography_default
};
